export default __webpack_public_path__ + "static/media/diploma-2024-dragon-madera.40dcbfb9.jpeg";